import React from "react";
import call from "../../assets/call.png";
import GetInTouch from "../Home/GetInTouch/GetInTouch";

const ConsultationTermsConditions = () => {
  return (
    <>
      <div class="hero for-inner">
        <div class="container">
          <div class="hero-grid inner">
            <div class="hero-w-width on-inner">
              <h1 class="display-1">
                Consultations Terms
                <span class="gray-text-color"> And Conditions</span>
              </h1>
            </div>
          </div>
        </div>
      </div>
      <div class="section legal">
        <div class="container">
          <div>
            <div class="leagl-wrapper">
              <div
                data-w-id="eb6b77d4-5c7b-d30c-b6da-7c7144717a91"
                class="legal-wrapper"
              >
                <div class="margin-30px">
                  <p class="terms-paragraph">
                    At{" "}
                    <strong>
                      ORE Migration Services PTY Ltd T/A Win Migration Group
                    </strong>
                    , our consultations are designed to provide you with
                    comprehensive migration advice in a 30-minute session.
                    During this time, our experienced migration agents and
                    lawyers will:
                  </p>
                  <ul role="list">
                    <li class="terms-list-item">
                      Understand your migration objectives
                    </li>
                    <li class="terms-list-item">
                      Evaluate your eligibility based on current migration laws
                      <strong>
                        Provide tailored pathways to achieve your migration
                        goals
                      </strong>
                    </li>
                    <li class="terms-list-item">
                      Discuss strategies to enhance your application’s strength
                    </li>
                    <li class="terms-list-item">
                      Outline the next steps in the migration process
                    </li>
                  </ul>
                </div>
                <div class="margin-30px">
                  <h4 class="heading-3">
                    <strong>Zero Tolerance for Online Harassment</strong>
                    <br />
                  </h4>
                </div>
                <div class="margin-30px">
                  <div class="rich-text-block-2 w-richtext">
                    <p class="terms-paragraph">
                      <strong>
                        ORE Migration Services PTY Ltd T/A Win Migration Group
                      </strong>{" "}
                      maintains a zero-tolerance policy for harassment,
                      disrespect, aggression, or discrimination during
                      consultations. Should such behavior occur, our agents and
                      lawyers reserve the right to terminate the session
                      immediately without issuing a refund. We believe in
                      maintaining a respectful and professional environment for
                      all.
                    </p>
                  </div>
                </div>
                <div class="margin-30px">
                  <h4>
                    <strong class="bold-text">
                      Cancellations, Reschedules, and Refunds
                    </strong>
                    <br />
                  </h4>
                </div>
                <div class="margin-30px">
                  <div class="rich-text-block-2 w-richtext">
                    <p class="terms-paragraph">
                      We understand that plans change. To ensure a smooth
                      experience, please review our cancellation and reschedule
                      policy:
                    </p>
                    <ul role="list">
                      <li class="terms-list-item">
                        Cancellations: You may cancel your appointment up to 48
                        hours before the scheduled time for a full refund. To
                        cancel, please follow the instructions in your
                        appointment confirmation email or contact us at{" "}
                        <a>contact@winmigrationgroup.com</a>.
                      </li>
                      <li class="terms-list-item">
                        Rescheduling: If you need to reschedule, you may do so
                        without any penalty if done at least 24 hours in
                        advance. Reschedules requested within 24 hours of the
                        consultation will incur an administrative fee of $50.
                      </li>
                      <li class="terms-list-item">
                        No-show or Late Cancellations: Cancellations made within
                        48 hours of the appointment or failure to attend the
                        consultation will result in the forfeiture of the
                        consultation fee, with no refund issued.
                      </li>
                    </ul>
                    <p>
                      Please note that consultation fees are not deductible from
                      future applications or services. If you have further
                      questions after your initial consultation, a new
                      consultation will be required.
                    </p>
                  </div>
                </div>
                <div class="margin-30px">
                  <h4>
                    <strong class="bold-text">Unexpected Changes</strong>
                    <br />
                  </h4>
                </div>
                <div class="margin-30px">
                  <div class="rich-text-block-2 w-richtext">
                    <p class="terms-paragraph">
                      In rare circumstances, we may need to reschedule or cancel
                      your appointment due to unforeseen issues on our end. If
                      this occurs, we will notify you promptly and make every
                      effort to reschedule your consultation at the earliest
                      available time with one of our experienced agents or
                      lawyers.
                    </p>
                  </div>
                </div>

                <div class="margin-30px">
                  <div class="rich-text-block-2 w-richtext">
                    <p>
                      ORE Migration Services PTY Ltd T/A Win Migration Group ABN
                      11 640 885 623
                    </p>
                    <p>
                      Email:
                      <a href="mailto:contact@winmigrationgroup.com">
                        contact@winmigrationgroup.com
                      </a>
                    </p>
                    <p>Last updated: 17 Oct 2024</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <GetInTouch />
    </>
  );
};

export default ConsultationTermsConditions;
